module.exports = __webpack_public_path__ + "img/d085766.png";